export default __webpack_public_path__ + "static/media/bc-astriq.1ee577da.svg";